export enum VueButtonTypes {
  primary = 'btn btn-primary',
  primaryOutline = 'btn btn-outline-primary',
  default = 'btn btn-outline-secondary',
  danger = 'btn btn-danger'
}